export default {
    locale: state => state.locale,
    locales: state => state.locales,
}